export enum NodeType {
  FOLDER = 0,
  ITEM = 1
}
